
import Vue from "vue";

export default Vue.extend({
  name: "LoaderView",
  data: () => ({ loading: false }),
  methods: {},
});
